export const DEFAULT_MAX_FILE_SIZE: number = 100 * 2 ** 20; // 100 MB
export const DATAROOM_MAX_FILE_SIZE: number = 20 * 2 ** 20; // 20 MB
